import React, { useState } from 'react';
import Select from 'react-select';
import {
  Box,
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalCloseButton,
  ModalBody,
  ModalHeader,
  useDisclosure,
  useMediaQuery,
  VStack,
  Text,
} from '@chakra-ui/react';
import { components } from 'react-select';


const ResponsiveSelect = ({ options = [], label, selectedOption, value, onChange, placeholder = 'Select', popupPlaceHolderTitle = 'Select', lang }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [menuIsOpen, setMenuIsOpen] = useState(false);
  const [isMobile] = useMediaQuery('(max-width: 768px)');


  const handleMobileSelect = (option) => {
    onChange(option);
    onClose();
  };

  const CustomDropdownIndicator = (props) => {
    const { selectProps } = props;
    const { menuIsOpen, useCustomSvg, selectedVal} = selectProps;
    return (
      <components.DropdownIndicator {...props}>
        {useCustomSvg ? ((menuIsOpen || selectedVal) ? (
          <svg width="15" height="8" viewBox="0 0 15 8" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M2.01855 1.5L7.52811 6.5L13.0377 1.5" stroke="#CF4520" stroke-width="2.07861" stroke-linecap="square" />
          </svg>
        ) :
          <svg width="15" height="8" viewBox="0 0 15 8" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M2.01855 1.5L7.52811 6.5L13.0377 1.5" stroke="black" stroke-width="2.07861" stroke-linecap="square" />
          </svg>
        ) :
          null}
      </components.DropdownIndicator>
    );
  };


  return (
    <Box>
      {isMobile ? (
        <>
          <Button
            width={'184px'}
            height={'54px'}
            onClick={onOpen}
            borderRadius={'10px'}
            border={(isOpen || selectedOption?.[label]) ? "1px solid #CF4520" : "1px solid #979797"}
            fontWeight="700"
            rightIcon={(isOpen || selectedOption?.[label]) ? <svg style={{ position: 'absolute', right: '1.3rem', top: '1.5rem' }} width="15" height="8" viewBox="0 0 15 8" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M2.01855 1.5L7.52811 6.5L13.0377 1.5" stroke="#CF4520" stroke-width="2.07861" stroke-linecap="square" />
            </svg> : 
            <svg width="15" height="8" viewBox="0 0 15 8" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M2.01855 1.5L7.52811 6.5L13.0377 1.5" stroke="black" stroke-width="2.07861" stroke-linecap="square" />
          </svg>           
            }
            bg="white"
            _hover={{}}
          >
            <Box flex={1}
              fontSize={'16px'}
              fontFamily={lang == 'en' ? 'FedraSansStd-book' : "Mukta Malar"}
              textAlign={'left'}
              color={(isOpen || selectedOption?.[label]) ? "#28231E" : '#000'}>
              {selectedOption?.[label] || placeholder}</Box>
          </Button>

          <Modal isOpen={isOpen} onClose={onClose} motionPreset="slideInUp">
            <ModalOverlay bg={'#221E02BF'} />
            <ModalContent mt={'auto'} mb={0} bg={'white'} borderRadius="lg" p={4} pr={8}>
              <ModalCloseButton top={'1.8rem'} right={'1.5rem'} />
              <ModalHeader
                fontFamily={lang == 'en' ? 'FedraSansStd-book' : "Mukta Malar"} fontWeight="700" fontSize="22px" color="#02026C">
                {popupPlaceHolderTitle}
              </ModalHeader>
              <ModalBody
                mb={'1.5rem'}
                sx={{
                  '&::-webkit-scrollbar': {
                    width: '9px'
                  },
                  '&::-webkit-scrollbar-thumb': {
                    background: '#D87051',
                    borderRadius: '0px',
                  },
                  '&::-webkit-scrollbar-track': {
                    background: '#F5F0E5',
                  },
                }}
                maxH="320px" overflowY="auto">
                <VStack spacing={3} align="stretch">
                  {options.map((opt) => (
                    <Text
                      fontFamily={lang == 'en' ? 'FedraSansStd-book' : "Mukta Malar"}
                      fontSize={"16px"}
                      key={opt.value}
                      onClick={() => handleMobileSelect(opt)}
                      cursor="pointer"
                      color="#6D6358"
                    >
                      {opt[label]}
                    </Text>
                  ))}
                </VStack>
              </ModalBody>
            </ModalContent>
          </Modal>
        </>
      ) : (
        <Box w="184px">
          <Select
            onMenuOpen={() => setMenuIsOpen(true)}
            onMenuClose={() => setMenuIsOpen(false)}
            isSearchable={false}
            options={options}
            getOptionLabel={opt => opt[label]}
            value={value}
            onChange={onChange}
            placeholder={selectedOption?.[label] || placeholder}
            styles={{
              menu: (base) => ({
                ...base,
                fontFamily: lang == 'en' ? 'FedraSansStd-book' : "Mukta Malar",
                fontSize: '16px',
                fontWeight: 400,
                scrollbarWidth: 'thin',
                scrollbarColor: '#CF4520 #AEA49340',
              }),
              control: (base, state) => ({
                ...base,
                borderColor: (state.menuIsOpen || selectedOption?.[label]) ? '#CF4520' : '#979797',
                borderRadius: '8px',
                padding: '2px',
                fontWeight: 'bold',
                boxShadow: 'none',
                fontFamily: lang == 'en' ? 'FedraSansStd-book' : "Mukta Malar",
                fontSize: '16px',
                color: '#28231E',
                height: '54px',
                '&:hover': {}
              }),
              placeholder: (base) => ({
                ...base,
                fontWeight: '700', // customize as needed
                fontFamily: lang === 'en' ? 'FedraSansStd-book' : 'Mukta Malar',
                fontSize: '16px',
                color: (menuIsOpen || selectedOption?.[label]) ? '#28231E' : '#000', // placeholder color
                paddingLeft: '0.3rem'
              }),
              indicatorSeparator: () => ({ display: 'none' }),
              dropdownIndicator: (base) => ({
                ...base,
                paddingRight: '0.8rem',
              }),
            }}
            useCustomSvg={true}
            components={{ DropdownIndicator: CustomDropdownIndicator }}
            selectedVal={selectedOption?.[label]}
          />
        </Box>
      )}
    </Box>
  );
};

export default ResponsiveSelect;